import React from 'react';

import { Guid } from '../../../../store/model/guid';
import { MediaLibrarySingleAssetProvider } from '../MediaLibraryAssetProvider/MediaLibrarySingleAssetProvider';
import { WidgetType } from '@ael/core-api';

interface AssetWidgetData {
  assetUrl: string;
  assetName: string;
}

interface PdfWidgetDataProviderProps {
  assetId: Guid;
  widgetId: Guid;

  children: (data?: AssetWidgetData) => React.ReactNode;
}

export const PdfWidgetDataProvider: React.FC<PdfWidgetDataProviderProps> = (props) => {
  return (
    <MediaLibrarySingleAssetProvider<AssetWidgetData>
      assetId={props.assetId}
      widgetId={props.widgetId}
      widgetType={WidgetType.pdf}
    >
      {(data) => props.children(data)}
    </MediaLibrarySingleAssetProvider>
  );
};
